import { render, staticRenderFns } from "./OneBenefit.vue?vue&type=template&id=004a4ca6&scoped=true&"
import script from "./OneBenefit.vue?vue&type=script&lang=js&"
export * from "./OneBenefit.vue?vue&type=script&lang=js&"
import style0 from "./OneBenefit.vue?vue&type=style&index=0&id=004a4ca6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004a4ca6",
  null
  
)

export default component.exports